<p-toast [life]="3000" [sticky]="false"></p-toast>
<form class="form-horizontal" #form="ngForm" style="min-height: 100px" (ngSubmit)="onConfirm()" *ngIf="is_visible">
  <div class="form-group"
  [ngClass]="{'has-error':fieldsRequired['select-provider-user']}">
    <label class="control-label col-sm-3">
      {{ 'Provider' | translate }}:
    </label>
    <div class="col-12 col-sm-9 col-md-12" [ngClass]="'select-provider-user'">
      <div class="table-responsive" style="clear: both;">
        <table class="table table-hover providers-table"
          style="width: auto;" aria-label="providers-table">
          <thead style="background:#f9f9f9">
              <tr>
                <th scope="col">
                </th>
                <th scope="col">
                  {{ 'Name' | translate }}
                </th>
                <th scope="col" class="text-center">
                  {{ 'Phone' | translate }}
                </th>
                <th scope="col" class="text-center">
                  {{ 'Email' | translate }}
                </th>
                <th scope="col" class="text-center">
                  {{ 'Asignaciones' | translate }}
                </th>
                <th scope="col" class="text-center">
                  {{ 'SDS' | translate}}
                </th>
            </tr>
          </thead>
          <tbody>
            <tr
            *ngFor="let userpro of providers
            let i = index" 
            (click)="setClickedRow(i,userpro)"
            [class.active]="i == selectedRow">
              <td>
                <i class="unselected fa fa-check" aria-hidden="true">
                </i>
              </td>
              <td>{{userpro?.name}}</td>
              <td class="text-center">{{userpro?.phone_number}}</td>
              <td class="text-center">{{userpro?.email}}</td>
              <td class="text-center">{{userpro?.assigned_cases}}</td>
              <td class="text-center">
                <ng-container *ngIf="validateRol(userpro.roles, 'user_type_sds'); else notSds">
                  <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/sds/assets-desktop/Iconos/Modales/sds_icon.svg' | company" alt="icon" width="25" height="25" style="margin-right: 8px;" />
                </ng-container>
                <ng-template #notSds>
                  <p>...</p>
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="showEstimatedTime">
      <label class="control-label">
        {{ 'Estimated time arrival' | translate }}:
      </label>
      <div>
        <input step="0.01" type="number" name="timeestimated" class="form-control"
          placeholder="{{ 'Minutes' | translate }}" [(ngModel)]="time_estimated">
      </div>
    </div>
    <div class="form-group">
      <label class="control-label col-sm-3">{{ 'Comment' | translate }}:</label>
      <div class="col-12 col-sm-9 col-md-12">
        <textarea rows="5" cols="10" class="form-control"
                  [(ngModel)]="comment" name="comment" required>
        </textarea>
      </div>
    </div>
    <div class="form-group" visible="false">
      <div class="col-12 col-sm-offset-3 col-sm-9 col-md-12 div-btn-right">
        <button type="submit"
        [disabled]="form.form.invalid || form.form.pending || isDisabled" 
        class="btn btn-primary btn-sm btn-right">
          {{ 'Assign Provider' | translate }}
        </button>
        <button 
        type="button" 
        class="btn btn-default btn-sm btn-right" 
        (click)="resetSelection()">{{ 'Cancel' | translate }}</button>
      </div>
    </div>
  </div>
</form>
<div class="confirm_assignation" *ngIf="is_confirmation_visible">
  <div class="row">
    <div class="col-md-12 text-center">
      <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/exclamation-circle.svg' | company" width="80px" style="aspect-ratio: 1/1;" alt="">
      <br>
      <h2 class="mt-4">Asignar Proveedor</h2>
      <br>
      <p style="margin: auto; width: 60%;">Está a punto de asignar un proveedor que ya tiene casos asignados.</p>
      <br>
      <p>¿Desea continuar?</p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <button class="btn secundary-btn secundary-btn-fw" (click)="closeDisclosure(true)"> {{ 'Cancelar' | translate }} </button>
    </div>
    <div class="col-md-6">
      <button class="btn primary-btn btn primary-btn-fw m-0" (click)="onSubmit()"> {{ 'Continuar' | translate }} </button>
    </div>
  </div>
</div>